module.exports = __webpack_public_path__ + "img/cap_13.f1d0f692.jpg";